import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import useSelectedProperty from './useSelectedProperty';
import {
  applyDoNotWishToProvideRule,
  getIsValidProgramAndStateCode,
} from './utils/useMultiRaceSelect';

// Shared fallback so a property without programs doesn't hand the memo
// below a new array every render.
const NO_AFFORDABLE_PROGRAMS = [];

const useMultiRaceSelect = () => {
  const { raceMultiSelect } = useFlags();
  const { state, pap = NO_AFFORDABLE_PROGRAMS } = useSelectedProperty() ?? {};
  const isValidProgramAndStateCode = getIsValidProgramAndStateCode(
    pap,
    state?.code,
  );
  // Memoized so callers can pass it straight into their own memo deps.
  const affordablePrograms = useMemo(
    () =>
      pap
        .map((program) => program?.masterAffordableProgram?.name)
        .filter(Boolean),
    [pap],
  );

  const handleItem = (item, onChange) =>
    onChange(applyDoNotWishToProvideRule(item));

  return {
    showMultiSelect: isValidProgramAndStateCode && raceMultiSelect,
    stateCode: state?.code,
    affordablePrograms,
    handleItem,
  };
};

export default useMultiRaceSelect;
